import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';

/**
 * Module Init
 */
(() => {
  const moduleSelector = '.icon-cards';
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.icon-cards__container').insertAdjacentHTML('beforeend', /* html */ `
          <div class="card splide__slide">
            <div class="icon">
              <img src="${item.icon}">
            </div>
            <div class="content">
              <h4 class="title">${item.title}</h4>
              <p class="description">${item.description}</p>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * Slider settings
 */
(() => {
  document.querySelectorAll('.icon-cards')
    .forEach((item) => {
      const cardAmount = item.querySelectorAll('.splide__slide').length;

      const slider = new Splide(item, {
        type: 'slide', // 'slide', 'loop' or 'fade'
        perPage: 4, // how many items to show
        perMove: 1, // how many items to show when clicking next/prev
        gap: 30, // space between items
        pagination: cardAmount > 4, // show dots only if more than 4 slides
        arrows: cardAmount > 4, // show arrows only if more than 4 slides
        autoplay: false, // turn it on
        setInterval: 5000, // time between slides
        drag: cardAmount > 4, // disable drag if all slides are visible
        breakpoints: {
          1469: {
            perPage: 3,
            pagination: cardAmount > 3,
            arrows: cardAmount > 3,
            drag: cardAmount > 3,
          },
          1024: {
            perPage: 2,
            pagination: cardAmount > 2,
            arrows: cardAmount > 2,
            drag: cardAmount > 2,
          },
          768: {
            perPage: 1,
            pagination: cardAmount > 1,
            arrows: cardAmount > 1,
            drag: cardAmount > 1,
          },
        },
      });
      slider.mount();
    });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
